import React, { useEffect, useState, useMemo, useRef } from 'react';
import './VisualDocumentation.scss';
import Swal from 'sweetalert2';
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC';
import { getUploadFileRequest } from '../../../../../base/utils/dataHelper';
import { PostDocApi } from '../services/postDocApi';
import { GetDocListApi } from '../services/getDocListApi';
import { IDocList } from '../models/responseModel';
import Table from '../../../../../components/Table';
import moment from 'moment';
import { Link } from 'react-router-dom';
import IPButton from '../../../../../components/IPButton';
import { DeleteDocApi } from '../services/deleteDocApi';



function DocumentUpload(props: BaseComponentWithContextProps) {
  const inputEl: any = useRef(null)
  const [fileList, setFileList] = useState<IDocList[]>([])


  const handleImageFileUpload = async (e: any) => {
    const fileList: any[] = await getUploadFileRequest(e)
    for (const fileData of fileList) {
      if (fileData.size > 50000000) {
        return Swal.fire('Hata', 'Her resim 50 MB\'den küçük olmalıdır!', 'error');
      }

      const allowedTypes = ['.jpeg', '.png', '.gif', '.jpg', '.vnd.openxmlformats-officedocument.wordprocessingml.document', '.xlsx', '.pdf', '.mp4'];
      if (!allowedTypes.includes(fileData.Extension)) {
        return Swal.fire('Hata', 'Hatalı dosya formatı! Sayfayı yeniledikten sonra tekrar deneyiniz.', 'error');
      }
      if (fileData.Extension === '.vnd.openxmlformats-officedocument.wordprocessingml.document')
        fileData.Extension = ".docx"
    }

    // Create the Files array from the fileList array
    const data = {
      Files: fileList.map((fileData, index) => ({
        Id: index,
        Label: '',
        Description: '',
        File: fileData,
      })),
    };

    const postImage: PostDocApi = new PostDocApi({});
    postImage
      .addDoc(data)
      .then((result: any) => {
        getList()
        Swal.fire({
          icon: 'success',
          title: result,
          showConfirmButton: true,
          allowOutsideClick: false,
        });
      })
      .catch((err: any) => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        });
      });
  }

  const getList = async () => {
    const listApi = new GetDocListApi({});
    const list = await listApi.getList().then((res) => {
      setFileList(res)
    })
  }

  useEffect(() => {
    getList();
  }, []);

  const tableColumns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'col1',
      },
      {
        Header: 'Dosya Adı',
        accessor: 'Name',
      },
      {
        Header: 'Yükleyen',
        accessor: 'UserName',
      },
      {
        Header: 'Tarih',
        accessor: 'Date',
      },
      {
        Header: 'İşlemler',
        accessor: 'delete',
      },
    ],
    []
  )

  const tableData = useMemo(
    () =>
      fileList.map((item, index) => {
        const data = {
          col1: index + 1,
          Name: <Link to={item.URL} target='_blank'>{item.Name}</Link>,
          UserName: item.UserName,
          Date: moment(item.Date).format("DD.MM.YYYY"),
          delete: <IPButton
            onClick={() => {
              Swal.fire({
                title: 'Bu dokümanı silmek istediğinize emin misiniz?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Evet, sil!',
                cancelButtonText: 'Hayır, iptal et!',
              }).then((result) => {
                if (result.isConfirmed) {
                  const deleteApi = new DeleteDocApi({});
                  try {
                    deleteApi.deleteDoc(item.URL).then((res) => {
                      if (res) {
                        Swal.fire('Silindi!', 'Doküman başarıyla silindi.', 'success');
                        getList();
                      }
                      else {
                        Swal.fire('Hata!', 'Doküman silinirken bir hata oluştu.', 'error');
                      }
                    }).catch((err) => {
                      Swal.fire({
                        icon: 'error',
                        title: 'Hata',
                        text: 'Doküman silinirken bir hata oluştu.' + err.description,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                      })
                    })
                  }
                  catch (err: any) {
                    Swal.fire({
                      icon: 'error',
                      title: 'Hata',
                      text: 'Doküman silinirken bir hata oluştu.' + err.description,
                      showConfirmButton: true,
                      allowOutsideClick: false,
                    })
                  }

                }
              });
            }} text={'Sil'} />
        }

        return data;
      }),
    [fileList]
  );

  return (
    <div className='container'>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header'>
            <span className='h4'>
              {'Doküman Yükleme'}
            </span>
          </div>
          <div className='card-body'>
            <div className='row'>
              <div className='col-md-4'>
                <div className='your-recent-visits text-center' style={{ minHeight: '300px', height: '300px' }}>
                  <i
                    className='icon-plus'
                    style={{ fontSize: '150px', color: '#adb5bd' }}
                    onClick={() => inputEl.current.click()}
                  ></i>
                  <input
                    ref={inputEl}
                    type='file'
                    name='mobilImage'
                    className='form-control'
                    id='mobilImage'
                    style={{ display: 'none' }}
                    onChange={event => {
                      handleImageFileUpload(event)
                    }}
                  />
                  <br />
                  <h5 style={{ color: '#adb5bd' }}>Dosya Yükle</h5>
                </div>
              </div>
            </div>
            <div className='row mt-4'>
              <div className='col-md-12'>
                <Table columns={tableColumns} data={tableData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}
export default componentWithContext(DocumentUpload);